import { Skeleton, SkeletonText, Stack, VisuallyHidden } from '@chakra-ui/react'
import { useT } from '~/i18n/use-t'

/** The loading state of a step: the shape of a form, announced as "Loading..." (Chakra's pulse stops under reduced motion). */
export const StepSkeleton = () => {
  const { t } = useT()
  return (
    <Stack gap={5} aria-busy='true' role='status'>
      <VisuallyHidden>{t('common.loading')}</VisuallyHidden>
      <SkeletonText noOfLines={2} gap={3} />
      <Skeleton h='12' borderRadius='md' />
      <Skeleton h='12' borderRadius='md' />
      <Skeleton h='12' w='40%' borderRadius='md' />
    </Stack>
  )
}
